/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */
import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { cssMap, cx, jsx } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { PromptAgentAvatar } from '../../../common/ui/prompt-agent-avatar';

import messages from './messages';

const styles = cssMap({
	agentHeader: {
		width: '100%',
		position: 'absolute',
		top: 0,
		left: 0,
		height: '48px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderTopLeftRadius: token('radius.xxlarge'),
		borderTopRightRadius: token('radius.xxlarge'),
		paddingInline: token('space.200'),
		paddingBlock: token('space.100'),
		font: token('font.heading.xsmall'),
	},

	compact: {
		paddingInline: token('space.150'),
	},
});

type AgentHeaderProps = {
	agent: Agent;
	removeAgent: () => void;
	compact: boolean | undefined;
};

export const AgentHeader = ({ agent, removeAgent, compact }: AgentHeaderProps) => {
	const { formatMessage } = useIntl();
	return (
		<Inline
			xcss={cx(styles.agentHeader, compact && styles.compact)}
			spread="space-between"
			alignBlock="center"
		>
			<Inline space="space.100" alignBlock="center">
				<PromptAgentAvatar agent={agent} />
				<span>{agent.name}</span>
			</Inline>
			<IconButton
				icon={CrossIcon}
				label={formatMessage(messages.removeAgentLabel)}
				appearance="subtle"
				onClick={removeAgent}
			/>
		</Inline>
	);
};
